import { useCashfitParams } from '@/view/hooks/use-params'
import { List, PlusCircle } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger } from '../../../components/ui/tabs'
import { ListProducts } from './components/list-products'
import { ListServices } from './components/list-services'
import { RegisterProduct } from './components/register-product'
import { RegisterService } from './components/register-service'

type Tabs = 'products' | 'create-product' | 'services' | 'create-service'

export function ServicesAndProducts() {
  const { getParam, setParams } = useCashfitParams<Tabs>({
    navId: '18',
    tabSelected: 'products'
  })

  const tab = getParam('tabSelected')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs
            defaultValue={getParam('tabSelected') || 'studants'}
            value={getParam('tabSelected') || 'studants'}
            onValueChange={(value) => {
              setParams({
                tabSelected: value as keyof Tabs
              })
            }}
          >
            <TabsList>
              <TabsTrigger
                onClick={() =>
                  setParams({
                    tabProductId: '' as any,
                    tabServiceId: '' as any
                  })
                }
                value="products"
                className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2"
              >
                <List className="text-sm" />
                Lista de Produtos
              </TabsTrigger>
              <TabsTrigger value="create-product" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Produto
              </TabsTrigger>
              <TabsTrigger
                onClick={() =>
                  setParams({
                    tabProductId: '' as any,
                    tabServiceId: '' as any
                  })
                }
                value="services"
                className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2"
              >
                <List className="text-sm" />
                Lista de Serviços
              </TabsTrigger>
              <TabsTrigger value="create-service" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Cadastrar Serviço
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'services' && <ListServices />}
          {tab == 'products' && <ListProducts />}
          {tab == 'create-service' && <RegisterService id={getParam('tabServiceId') || ''} />}
          {tab == 'create-product' && <RegisterProduct id={getParam('tabProductId') || ''} />}
        </div>
      </main>
    </div>
  )
}
